/*
 * A&M JOYAS - Selector de paquetes Compra 1 / Duo / Trio (snippets/product-pack-picker.liquid).
 *
 * Compra 1: agrega una variante del producto base.
 * Duo: la clienta elige 2 modelos (pueden repetirse); se agrega la variante del producto
 *      Duo que corresponde a esa pareja.
 * Trio: se agrega el producto Trio (los 3 modelos fijos, siempre distintos).
 * Cada paquete entra al carrito como 1 sola linea y descuenta el stock del producto base.
 *
 * El selector tiene en cuenta lo que ya hay en el carrito: si de un modelo ya estan
 * todas las unidades disponibles en el carrito, ese modelo aparece como "limite alcanzado"
 * y no se puede elegir; una tarjeta sin opciones posibles se apaga y explica el motivo;
 * y si no queda ninguna opcion posible, el boton se desactiva.
 *
 * Al elegir un modelo, la galeria de fotos del producto cambia a la foto de ese modelo.
 * Al elegir Duo o Trio se vuelve a la foto grupal.
 *
 * En la pagina del producto, las tarjetas se suben justo encima del selector de cantidad
 * nativo (que se oculta, porque aqui la cantidad siempre es 1 por paquete; la clienta
 * puede cambiarla despues en el carrito) y reemplazan al selector de modelo nativo.
 * El boton "Agregar al carrito" se queda en su lugar de siempre (debajo de la barra
 * del 15%), igual que en el resto de los productos, y el aviso de error aparece
 * justo encima de ese boton, con el mismo estilo que los demas productos.
 *
 * Igual que el formulario nativo del tema, al agregar se le quita la clase "is-empty" al
 * carrito lateral (si la pagina se cargo con el carrito vacio), para que se vea completo.
 *
 * La barra de progreso del 15% (bloque de la pagina del producto) se actualiza con el
 * evento "cart:updated"; como este selector no usa el formulario nativo, se dispara ese
 * evento al agregar y cada vez que el carrito cambia (por ejemplo, desde el carrito lateral).
 */
(function () {
  if (window.__packPickerInit) return;
  window.__packPickerInit = true;

  function avisarBarraPromo() {
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function init(root) {
    var data = window.__packPickerData;
    if (!data || !data.single || data.single.length < 2) return;

    var cards = root.querySelectorAll('.pack-card');
    var addBtn = root.querySelector('[data-pack-add]');
    var addLabel = root.querySelector('[data-pack-add-label]');
    var errorEl = root.querySelector('[data-pack-error]');
    var errorTextEl = root.querySelector('[data-pack-error-text]');
    var selSingle = root.querySelector('[data-slot="single"]');
    var selA = root.querySelector('[data-slot="duo-1"]');
    var selB = root.querySelector('[data-slot="duo-2"]');
    if (!addBtn || !selSingle || !selA || !selB) return;

    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var models = data.single.map(function (v) { return v.title; });
    var used = {};

    var styleEl = document.createElement('style');
    styleEl.textContent =
      '.pack-picker .pack-card.is-soldout { opacity: 1; }' +
      '.pack-picker .pack-card.is-soldout .pack-card__name, .pack-picker .pack-card.is-soldout .pack-card__prices, .pack-picker .pack-card.is-soldout .pack-card__desc { opacity: 0.5; }' +
      '.pack-picker .pack-card__note { display: block; font-size: 1.2rem; line-height: 1.4; color: #991b1b; margin-top: 0.3rem; }' +
      '.pack-picker .pack-card__note[hidden] { display: none; }';
    document.head.appendChild(styleEl);

    cards.forEach(function (c) {
      var left = c.querySelector('.pack-card__left');
      if (!left) return;
      var n = document.createElement('span');
      n.className = 'pack-card__note';
      n.hidden = true;
      left.appendChild(n);
    });

    function showMedia(mediaId) {
      if (!mediaId) return;
      var gallery = document.querySelector('media-gallery');
      if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
      var sectionId = String(gallery.id || '').replace('MediaGallery-', '');
      try { gallery.setActiveMedia(sectionId + '-' + mediaId, false); } catch (e) {}
    }
    function mediaOfModel(title) {
      var v = data.single.filter(function (x) { return x.title === title; })[0];
      return v ? v.media : 0;
    }

    function singleAvailable(title) {
      return data.single.some(function (v) { return v.title === title && v.available; });
    }
    function stockOf(title) {
      var v = data.single.filter(function (x) { return x.title === title; })[0];
      if (!v) return 0;
      if (!v.tracked) return Infinity;
      return Math.max(v.qty, 0);
    }
    function remaining(title) {
      return stockOf(title) - (used[title] || 0);
    }
    function duoVariant(a, b) {
      return data.duo.filter(function (v) { return v.o1 === a && v.o2 === b; })[0] || null;
    }
    function pairOk(a, b) {
      var v = duoVariant(a, b);
      return !!(v && v.available);
    }
    function singleOk(m) {
      return singleAvailable(m) && remaining(m) >= 1;
    }
    function pairOkCart(a, b) {
      if (!pairOk(a, b)) return false;
      if (a === b) return remaining(a) >= 2;
      return remaining(a) >= 1 && remaining(b) >= 1;
    }
    function trioOk() {
      return !!data.trio.available && models.every(function (m) { return remaining(m) >= 1; });
    }
    function firstPairWith(test, distinctOnly) {
      for (var i = 0; i < models.length; i++) {
        for (var j = 0; j < models.length; j++) {
          if (distinctOnly && i === j) continue;
          if (test(models[i], models[j])) return [models[i], models[j]];
        }
      }
      return null;
    }
    function joinList(arr) {
      if (arr.length <= 1) return arr.join('');
      return arr.slice(0, -1).join(', ') + ' y ' + arr[arr.length - 1];
    }

    var state = { pack: 'single', single: models[0], a: models[0], b: models[1] };
    var firstSingle = data.single.filter(function (v) { return v.available; })[0];
    if (firstSingle) state.single = firstSingle.title;
    var fp = firstPairWith(pairOk, true) || firstPairWith(pairOk, false);
    if (fp) { state.a = fp[0]; state.b = fp[1]; }

    function noteFor(key) {
      var anyStock = {
        single: data.single.some(function (v) { return v.available; }),
        duo: data.duo.some(function (v) { return v.available; }),
        trio: !!data.trio.available
      };
      if (!anyStock[key]) return 'Sin stock disponible.';
      var limited = models.filter(function (m) { return singleAvailable(m) && remaining(m) < 1; });
      if (!limited.length) return 'Límite de stock alcanzado.';
      return 'Límite de stock alcanzado: ya tienes en tu carrito todas las unidades de ' + joinList(limited) + '.';
    }

    function fillSelect(select, selected, reason) {
      select.innerHTML = '';
      models.forEach(function (m) {
        var opt = document.createElement('option');
        var why = reason(m);
        opt.value = m;
        opt.textContent = why ? m + ' (' + why + ')' : m;
        if (why) opt.disabled = true;
        if (m === selected) opt.selected = true;
        select.appendChild(opt);
      });
    }

    function currentId() {
      if (state.pack === 'single') {
        var s = data.single.filter(function (v) { return v.title === state.single; })[0];
        return s && singleOk(state.single) ? s.id : null;
      }
      if (state.pack === 'duo') {
        var d = duoVariant(state.a, state.b);
        return d && pairOkCart(state.a, state.b) ? d.id : null;
      }
      return trioOk() ? data.trio.id : null;
    }

    function stockOnlyOk() {
      if (state.pack === 'single') return singleAvailable(state.single);
      if (state.pack === 'duo') return pairOk(state.a, state.b);
      return !!data.trio.available;
    }

    function selectedList() {
      if (state.pack === 'single') return state.single;
      if (state.pack === 'duo') {
        if (state.a === state.b) return state.a + ' (2 unidades)';
        return state.a + ' y ' + state.b;
      }
      return joinList(models);
    }

    function stockMessage() {
      if (state.pack === 'single') return 'Tu carrito ya tiene la cantidad máxima de este artículo.';
      return 'Tu carrito ya tiene la cantidad máxima de alguno de estos modelos: ' + selectedList() + '.';
    }

    function showError(msg) {
      if (!errorEl) return;
      (errorTextEl || errorEl).textContent = msg;
      errorEl.hidden = false;
    }
    function hideError() {
      if (errorEl) errorEl.hidden = true;
    }

    function render() {
      if (!singleOk(state.single)) {
        var s1 = models.filter(singleOk)[0];
        if (s1) state.single = s1;
      }
      if (!pairOkCart(state.a, state.b)) {
        var alt = models.filter(function (m) { return pairOkCart(state.a, m); })[0];
        if (alt) {
          state.b = alt;
        } else {
          var fp2 = firstPairWith(pairOkCart, true) || firstPairWith(pairOkCart, false);
          if (fp2) { state.a = fp2[0]; state.b = fp2[1]; }
        }
      }

      fillSelect(selSingle, state.single, function (m) {
        if (!singleAvailable(m)) return 'agotado';
        return remaining(m) >= 1 ? '' : 'límite alcanzado';
      });
      fillSelect(selA, state.a, function (m) {
        if (!models.some(function (o) { return pairOk(m, o); })) return 'agotado';
        return models.some(function (o) { return pairOkCart(m, o); }) ? '' : 'límite alcanzado';
      });
      fillSelect(selB, state.b, function (m) {
        if (!pairOk(state.a, m)) return 'agotado';
        return pairOkCart(state.a, m) ? '' : 'límite alcanzado';
      });

      var anyAvailable = {
        single: models.some(singleOk),
        duo: models.some(function (a) { return models.some(function (b) { return pairOkCart(a, b); }); }),
        trio: trioOk()
      };

      if (!anyAvailable[state.pack]) {
        var next = ['single', 'duo', 'trio'].filter(function (k) { return anyAvailable[k]; })[0];
        if (next) state.pack = next;
      }

      cards.forEach(function (c) {
        var key = c.getAttribute('data-pack');
        var radio = c.querySelector('.pack-card__radio');
        var note = c.querySelector('.pack-card__note');
        var on = key === state.pack;
        c.classList.toggle('is-selected', on);
        c.classList.toggle('is-soldout', !anyAvailable[key]);
        if (radio) {
          radio.checked = on;
          radio.disabled = !anyAvailable[key];
        }
        if (note) {
          if (anyAvailable[key]) {
            note.hidden = true;
          } else {
            note.textContent = noteFor(key);
            note.hidden = false;
          }
        }
      });

      var ok = currentId() !== null;
      addBtn.disabled = !ok;
      if (ok) addLabel.textContent = 'Agregar al carrito';
      else addLabel.textContent = stockOnlyOk() ? 'Límite de stock alcanzado' : 'No disponible';
    }

    function loadCart() {
      return fetch(shopRoot + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var u = {};
          function add(m, n) { u[m] = (u[m] || 0) + n; }
          (cart.items || []).forEach(function (it) {
            var q = it.quantity;
            var s = data.single.filter(function (v) { return v.id === it.variant_id; })[0];
            if (s) { add(s.title, q); return; }
            var d = data.duo.filter(function (v) { return v.id === it.variant_id; })[0];
            if (d) { add(d.o1, q); add(d.o2, q); return; }
            if (it.variant_id === data.trio.id) {
              models.forEach(function (m) { add(m, q); });
            }
          });
          used = u;
          render();
        })
        .catch(function () {});
    }

    cards.forEach(function (c) {
      var radio = c.querySelector('.pack-card__radio');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (radio.checked) {
          state.pack = c.getAttribute('data-pack');
          hideError();
          render();
          if (state.pack === 'single') showMedia(mediaOfModel(state.single));
          else showMedia(data.groupMedia);
        }
      });
    });
    selSingle.addEventListener('change', function () { state.single = selSingle.value; hideError(); render(); showMedia(mediaOfModel(state.single)); });
    selA.addEventListener('change', function () { state.a = selA.value; hideError(); render(); showMedia(mediaOfModel(state.a)); });
    selB.addEventListener('change', function () { state.b = selB.value; hideError(); render(); showMedia(mediaOfModel(state.b)); });

    function addToCart(id) {
      var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var canRender = !!(cartEl && typeof cartEl.getSectionsToRender === 'function' && typeof cartEl.renderContents === 'function');
      var body = { items: [{ id: id, quantity: 1 }] };
      if (canRender) {
        body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      return fetch(shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            var text = String(res.description || res.message || '');
            var e = new Error(text || 'No se pudo agregar al carrito.');
            e.isStock = (res.status === 422) || /agotad|sold out|stock|carrito|cart/i.test(text);
            throw e;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-pack-picker', productVariantId: id, cartData: res });
          }
          avisarBarraPromo();
          setTimeout(avisarBarraPromo, 700);
          if (canRender) {
            try {
              if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
              cartEl.renderContents(res);
              return;
            } catch (e2) {}
          }
          window.location.href = shopRoot + 'cart';
        });
    }

    addBtn.addEventListener('click', function () {
      var id = currentId();
      if (id === null) return;
      hideError();
      addBtn.disabled = true;
      addLabel.textContent = 'Agregando...';
      addToCart(id)
        .catch(function (err) {
          if (err && err.isStock) showError(stockMessage());
          else showError(err && err.message ? err.message : 'No se pudo agregar al carrito.');
        })
        .then(function () { return loadCart(); })
        .then(function () { render(); });
    });

    var qtyForm = document.querySelector('[id^="Quantity-Form-"]');
    if (qtyForm) {
      qtyForm.style.setProperty('display', 'none', 'important');
      if (qtyForm.parentNode) {
        var origParent = root.parentNode;
        var origNext = root.nextSibling;
        qtyForm.parentNode.insertBefore(root, qtyForm);
        if (origParent) {
          addBtn.style.marginBottom = '1rem';
          origParent.insertBefore(addBtn, origNext);
        }
      }
    }
    if (errorEl && addBtn.parentNode) {
      addBtn.parentNode.insertBefore(errorEl, addBtn);
    }

    document.documentElement.classList.add('has-pack-picker');
    render();
    loadCart();

    var tries = 0;
    function subscribeCart() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { loadCart(); avisarBarraPromo(); });
      } else if (tries < 20) {
        tries++;
        setTimeout(subscribeCart, 300);
      }
    }
    subscribeCart();
    window.addEventListener('pageshow', function () { loadCart(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) loadCart(); });
  }

  function start() {
    document.querySelectorAll('[data-pack-picker]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
